module.exports = __webpack_public_path__ + "img/headSculpture2.32cbce8f.png";